export const recruitmentProcessData = {
  mainText: `Check our recruitment process`,
  description: `Learn more about the recruitment process at Rumble Fish. Our HR team will accompany you every step of the way.`,
  services: [
    {
      step: '1',
      title: `Send us your application`,
      description: `Start by sending us your resume so we can get an overview of your experience and skills.`,
    },
    {
      step: '2',
      title: `Phone screening`,
      description: `If your CV matches the profile, we’ll arrange a 15-minute interview to get to know each other better.`,
    },
    {
      step: '3',
      title: `Recruitment task`,
      description: `We’ll give you a task so that you can showcase your skills. We can skip this step if you’ll show us some of your amazing code.`,
    },
    {
      step: '4',
      title: 'Meeting in the office',
      description: `Now we invite you to our office in Kraków for a technical interview. We can also do it online.`,
    },
    {
      step: '5',
      title: `The result`,
      description: `We’ll inform you about our decision within a few days.`,
    },
  ],
};
